// test1390
(1390 && 0);
